import React, { useContext } from 'react'
import { Spacer, Text, View } from 'oio-react'
import { CheckmarkIcon, LockGlyph24Icon } from 'assets/icons'
import InitiativeStatusBanner from 'src/apps/Initiative/components/StatusBanner'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const DiscussionStatusBanner = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)

   if (initiative.discussionStatus.closed) {
      return (
         <View
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="60px"
            backgroundColor="rgba(72, 193, 146, 0.1)"
            textAlign="center">
            {initiative.discussionFormat === 'discussion' && (
               <LockGlyph24Icon width="16px" height="16px" color="rgba(72, 193, 146, 1)" />
            )}
            {initiative.discussionFormat === 'qa' && (
               <CheckmarkIcon width="16px" height="16px" color="rgba(72, 193, 146, 1)" />
            )}
            <Spacer size="2" orientation="vertical" />
            <Text size="1.5[a-b] 2[c-f]" color="rgba(72, 193, 146, 1)">
               {initiative.discussionFormat === 'qa'
                  ? 'This question has been answered'
                  : 'This discussion thread is closed'
               }
            </Text>
         </View>
      )
   }

   return <InitiativeStatusBanner />
}

export default DiscussionStatusBanner
